import { render } from "./new-group-btn.vue?vue&type=template&id=41321765"
import script from "./new-group-btn.vue?vue&type=script&setup=true&lang=js"
export * from "./new-group-btn.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/settings/pages/location-groups/components/new-group-btn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "41321765"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('41321765', __exports__)) {
    console.log('reload')
    api.reload('41321765', __exports__)
  }
  
  module.hot.accept("./new-group-btn.vue?vue&type=template&id=41321765", () => {
    console.log('re-render')
    api.rerender('41321765', render)
  })

}


export default __exports__